import React, { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

const Login = () => {
    const navigate = useNavigate();
    const [urlParams] = useSearchParams();
    console.log("urlParams ---", urlParams.get('shopName'));
    // console.log("urlParams", urlParams.entries());
    useEffect(() => {
        // navigate('')
        window.location.href = `https://dashboard.causalfunnel.com/login?shopName=${urlParams.get('shopName')}`
    }, [])
  return (
      <div>
          
    </div>
  )
}

export default Login